import { useLayoutEffect as e } from "@radix-ui/react-use-layout-effect";
import * as t from "react";
var n,
    o = 0;
export function useBodyPointerEvents(_ref) {
  var r = _ref.disabled;
  var i = t.useRef(!1);
  e(function () {
    if (r) {
      function _e() {
        o--, 0 === o && (document.body.style.pointerEvents = n);
      }

      function _t(e) {
        i.current = "mouse" !== e.pointerType;
      }

      return 0 === o && (n = document.body.style.pointerEvents), document.body.style.pointerEvents = "none", o++, document.addEventListener("pointerup", _t), function () {
        i.current ? document.addEventListener("click", _e, {
          once: !0
        }) : _e(), document.removeEventListener("pointerup", _t);
      };
    }
  }, [r]);
}